import axios from 'api/axios'
import handleAxiosError from 'utils/handleAxiosError'

export interface SignalsCallLog {
	_id: string
	idempotencyKey: string
	number: string
	direction: string
	timestampLocal: string
	timestampUtc: string
	duration: number
	type: string
	agentId?: { firstName?: string; lastName?: string; email?: string }
	createdAt?: string
}

export const getSignalsCallLogs = async (
	clientId: string
): Promise<SignalsCallLog[]> => {
	try {
		const { data } = await axios.get<SignalsCallLog[]>(
			`api/signals/call-logs?clientId=${clientId}`
		)
		return data
	} catch (error: any) {
		handleAxiosError(error)
		throw error
	}
}

export default getSignalsCallLogs
